module.exports = __webpack_public_path__ + "static/media/Experten03.9201fb7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Experten03.jpg
// module id = 356
// module chunks = 0